import { Grid } from 'components/Grid/Grid';
import React, { FC, useState } from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import { Image } from 'components/Image/Image';
import styles from './CloverCareBonusSection.module.scss';
import { useContentfulCloverCareBonusQuery } from './useContentfulSoftwarePlansQuery/useContentfulCloverCareBonusQuery';
import { Button } from 'components/Button/Button';
import { FeaturesModal } from 'components/FeaturesModal/FeaturesModal';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import cx from 'classnames';
import { usePaymentsToggle } from 'components/Cart/OrderSummary/PaymentsToggle/usePaymentsToggle/usePaymentsToggle';
import { getCartProductsAndAccessories } from 'components/Cart/utils/getCartProductsAndAccessoriesUtils';
import { useCartContext } from 'components/Cart/hooks/useCartContext';

export const CloverCareBonusSection: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: cloverCareEntries } = useContentfulCloverCareBonusQuery();
  const { isPayMonthly } = usePaymentsToggle();
  const { cart } = useCartContext();
  const { payMonthlyProductsAndAccessories } = getCartProductsAndAccessories(cart);

  const cloverCareBonusSectionData = cloverCareEntries?.[0];
  const isUpFrontPlan = !isPayMonthly || payMonthlyProductsAndAccessories.length === 0;

  if (!cloverCareBonusSectionData || isUpFrontPlan) return null;

  const { image, blurb, title, modalFeatures, redirectUrl } = cloverCareBonusSectionData;

  const cloverCareModalFeatures = modalFeatures?.[0];

  return (
    <Grid container item xs={12}>
      <Grid item md={12} xs={12} className={styles.cloverCareBonusWrapper}>
        <Grid item className={styles.cloverCareBonusImage}>
          <Image className={styles.cloverCareBonusImageIcon} src={image?.file?.url} aria-hidden="true" />
        </Grid>
        <Grid item md={12} xs={12} className={styles.cloverCareBonusText}>
          <div className={styles.cloverCareBonusTextHeadingSectionContainer}>
            {redirectUrl ? (
              <ContentLinkV2
                hideTitle
                entry={redirectUrl}
                className={cx(
                  styles.cloverCareBonusTextHeadingSectionTitle,
                  styles.cloverCareBonusTextHeadingSectionUnderline,
                )}
              >
                {title}
              </ContentLinkV2>
            ) : (
              <Button
                className={cx(
                  styles.cloverCareBonusTextHeadingSectionTitle,
                  cloverCareModalFeatures && styles.cloverCareBonusTextHeadingSectionUnderline,
                  !cloverCareModalFeatures && styles.cloverCareBonusTextHeadingSectionCursorInitial,
                )}
                onClick={() => setIsOpen(true)}
              >
                {title}
              </Button>
            )}
            <span className={styles.cloverCareBonusTextHeadingSectionBadge}>Bonus</span>
          </div>
          <FeaturesModal modalState={[isOpen, () => setIsOpen(!isOpen)]} entries={cloverCareModalFeatures} />
          <TextV2 className={styles.cloverCareBonusTextBody} tagName="p" variant="body-small" value={blurb} />
        </Grid>
      </Grid>
    </Grid>
  );
};
